"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _layouts = require("@seedlang/layouts");
var _stores = require("@seedlang/stores");
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _constants = require("@seedlang/constants");
var _models = require("@seedlang/models");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _overlay_ui = _interopRequireDefault(require("./overlay_ui"));
var _exercise_ui = _interopRequireDefault(require("./exercise_ui"));
var _deck_ui = _interopRequireDefault(require("./deck_ui"));
var _tree_ui = _interopRequireDefault(require("./tree_ui"));
var _root_state = _interopRequireDefault(require("./root_state"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var AppUI = (_class = /*#__PURE__*/function (_RootState) {
  function AppUI(parent) {
    var _this;
    _classCallCheck(this, AppUI);
    _this = _callSuper(this, AppUI);
    _this.SIMULATE_MOBILE_AUTH = false;
    // also exists in api.js
    _this.ENABLE_MOBILE_LOGGING = false;
    // Disabled for development to reduce console noise
    _initializerDefineProperty(_this, "allowPageScroll", _descriptor, _this);
    _initializerDefineProperty(_this, "notificationsOpened", _descriptor2, _this);
    _initializerDefineProperty(_this, "streakPopupOpened", _descriptor3, _this);
    _initializerDefineProperty(_this, "submittingPayment", _descriptor4, _this);
    _initializerDefineProperty(_this, "usingDataSaverHeader", _descriptor5, _this);
    _initializerDefineProperty(_this, "registrationSubmitted", _descriptor6, _this);
    _initializerDefineProperty(_this, "hideOnboarding", _descriptor7, _this);
    _initializerDefineProperty(_this, "expandedEmailRegistrationFields", _descriptor8, _this);
    _initializerDefineProperty(_this, "loadingReviews", _descriptor9, _this);
    _initializerDefineProperty(_this, "blockRouteToHome", _descriptor10, _this);
    _initializerDefineProperty(_this, "reloadReviewDecks", _descriptor11, _this);
    _initializerDefineProperty(_this, "currentlyViewedMembership", _descriptor12, _this);
    _initializerDefineProperty(_this, "routeToMobile", _descriptor13, _this);
    _initializerDefineProperty(_this, "vocabWordTypeId", _descriptor14, _this);
    _initializerDefineProperty(_this, "nativeDevice", _descriptor15, _this);
    _initializerDefineProperty(_this, "mobileTabChangeTimeStamp", _descriptor16, _this);
    _initializerDefineProperty(_this, "showUpdateAppModal", _descriptor17, _this);
    _initializerDefineProperty(_this, "showUpdateLangModal", _descriptor18, _this);
    _initializerDefineProperty(_this, "showImagePickerModal", _descriptor19, _this);
    _initializerDefineProperty(_this, "showVocabModal", _descriptor20, _this);
    _initializerDefineProperty(_this, "clickedLinkId", _descriptor21, _this);
    _initializerDefineProperty(_this, "updatedDeviceLanguageId", _descriptor22, _this);
    _initializerDefineProperty(_this, "showFirstDeckCompletionModal", _descriptor23, _this);
    _initializerDefineProperty(_this, "onboardingDeckType", _descriptor24, _this);
    _initializerDefineProperty(_this, "onboardingDeckId", _descriptor25, _this);
    _initializerDefineProperty(_this, "onboardingTreeNodeId", _descriptor26, _this);
    _initializerDefineProperty(_this, "pageHasScrolled", _descriptor27, _this);
    _initializerDefineProperty(_this, "pageExpanded", _descriptor28, _this);
    _initializerDefineProperty(_this, "contentTreeScrollPosition", _descriptor29, _this);
    _initializerDefineProperty(_this, "worksheetGridScrollPosition", _descriptor30, _this);
    _initializerDefineProperty(_this, "contractedModulesAry", _descriptor31, _this);
    _initializerDefineProperty(_this, "onboardingLevelId", _descriptor32, _this);
    _initializerDefineProperty(_this, "onboardingLanguageId", _descriptor33, _this);
    _initializerDefineProperty(_this, "isBrowser", _descriptor34, _this);
    _this.parent = parent;
    _this.layout = new _layouts.AppLayout(_this);
    _this.api = _stores.Api;
    _this.soundEffectStore = _stores.SoundEffectStore;
    _this.xpState = _models.XpState;
    _this.analyticStore = _stores.AnalyticStore;
    _this.podcastEpisodeStore = _stores.PodcastEpisodeStore;
    _this.gridItemStore = _stores.GridItemStore;
    _this.gridItemWorksheetStore = _stores.GridItemWorksheetStore;
    _this.referrerOptionStore = _stores.ReferrerOptionStore;
    _this.tagCategoryStore = _stores.TagCategoryStore;
    _this.levelStore = _stores.LevelStore;
    _this.authUserStore = _stores.AuthUserStore;
    _this.userStore = _stores.UserStore;
    _this.bannerNoticeStore = _stores.BannerNoticeStore;
    _this.userDeckStore = _stores.UserDeckStore;
    _this.campaignStore = _stores.CampaignStore;
    _this.wordSearchStore = _stores.WordSearchStore;
    _this.languageStore = _stores.LanguageStore;
    _this.feedEntryStore = _stores.FeedEntryStore;
    _this.followAssociationStore = _stores.FollowAssociationStore;
    _this.commentStore = _stores.CommentStore;
    _this.followingStore = _stores.FollowingStore;
    _this.followerStore = _stores.FollowerStore;
    _this.contactMessageStore = _stores.ContactMessageStore;
    _this.contactCategoryStore = _stores.ContactCategoryStore;
    _this.routeStore = _stores.RouteStore;
    _this.notificationStore = _stores.AuthUserNotificationStore;
    _this.leaderboardStore = _stores.LeaderboardStore;
    _this.dailyXpCountStore = new _stores.DailyXpCountStore();
    _this.authUserDailyXpCountStore = new _stores.DailyXpCountStore();
    _this.feedbackStore = _stores.FeedbackStore;
    _this.serverStore = _stores.ServerStore;
    _this.treeStore = _stores.TreeStore;
    _this.pageStore = _stores.PageStore;
    _this.treeNodeStore = _stores.TreeNodeStore;
    _this.subscriptionStore = _stores.SubscriptionStore;
    _this.userBannerNoticeStore = _stores.UserBannerNoticeStore;
    _this.stripeStore = _stores.StripeStore;
    _this.userSubscriptionStore = _stores.UserSubscriptionStore;
    _this.membershipStore = _stores.MembershipStore;
    _this.membershipGroupStore = _stores.MembershipGroupStore;
    _this.membershipTypeStore = _stores.MembershipTypeStore;
    _this.wordTypeStore = _stores.WordTypeStore;
    _this.wordStore = _stores.WordStore;
    _this.deckStore = _stores.DeckStore;
    _this.paypalStore = _stores.PaypalStore;
    _this.eventStore = _stores.EventStore;
    _this.sentenceStore = _stores.SentenceStore;
    _this.wordSentenceStore = _stores.WordSentenceStore;
    _this.authenticateStore = _stores.AuthenticateStore;
    _this.dashboardStore = _stores.DashboardStore;
    _this.userTranslationStore = _stores.UserTranslationStore;
    _this.cardStore = _stores.CardStore;
    _this.downloadLinkTypeStore = _stores.DownloadLinkTypeStore;
    _this.downloadLinkStore = _stores.DownloadLinkStore;
    _this.conjugatedVerbStringStore = _stores.ConjugatedVerbStringStore;
    _this.teamStore = _stores.TeamStore;
    _this.promotedRatingStore = _stores.PromotedRatingStore;
    _this.translationSourceStore = _stores.TranslationSourceStore;
    _this.reviewStore = _stores.ReviewStore;
    _this.dailyReviewSummaryStore = _stores.DailyReviewSummaryStore;
    _this.userTreeNodeStore = _stores.UserTreeNodeStore;
    _this.userGroupStore = _stores.UserGroupStore;
    _this.siteReleaseStore = _stores.SiteReleaseStore;
    _this.sentenceSubmissionStore = _stores.SentenceSubmissionStore;
    _this.revenueCatStore = _stores.RevenueCatStore;
    _this.mobileNotificationTokenStore = _stores.MobileNotificationTokenStore;
    _this.reviewDeckStore = _stores.ReviewDeckStore;
    _this.allReviewDecksStore = _stores.AllReviewDecksStore;
    _this.cardTypeStore = _stores.CardTypeStore;
    _this.faqCategoryStore = _stores.FaqCategoryStore;
    _this.faqItemStore = _stores.FaqItemStore;
    _this.groupStore = _stores.GroupStore;
    _this.navigationItemStore = _stores.NavigationItemStore;
    _this.targetLanguageStore = _stores.TargetLanguageStore;
    _this.worksheetStore = _stores.WorksheetStore;
    _this.podcastStore = _stores.PodcastStore;
    _this.siteStore = _stores.SiteStore;
    _this.csrfStore = _stores.CsrfStore;
    _this.discordUserAssociationStore = _stores.DiscordUserAssociationStore;
    _this.discordRoleStore = _stores.DiscordRoleStore;
    _this.cookieStore = _stores.CookieStore;
    _this.patreonRewardStore = _stores.PatreonRewardStore;
    _this.videoClipStore = _stores.VideoClipStore;
    _this.paymentMigrationStore = _stores.PaymentMigrationStore;
    _this.promotionStore = _stores.PromotionStore;
    return _this;
  }
  _inherits(AppUI, _RootState);
  return _createClass(AppUI, [{
    key: "user",
    get: function get() {
      return this.authUserStore.showData;
    }
  }, {
    key: "userIsLoaded",
    get: function get() {
      var _this$user;
      return (0, _utils.isPresent)((_this$user = this.user) === null || _this$user === void 0 ? void 0 : _this$user.id);
    }
  }, {
    key: "userId",
    get: function get() {
      if (this.userIsLoaded) {
        return this.user.id;
      }
    }
  }, {
    key: "permissions",
    get: function get() {
      var obj = (0, _utils.isPresent)(this.user.currentUserGroup) ? this.user.currentUserGroup : this.user;
      return new _models.Permissions(obj);
    }
  }, {
    key: "contentLinks",
    get: function get() {
      var _this2 = this;
      var contentLinks = [{
        background: _constants.Theme.blue,
        slug: 'stories',
        title: 'Stories',
        description: 'View our structured learning program. Learn grammar, practice speaking and listening, and learn new vocabulary.',
        webRoute: 'stories.home',
        mobileRoute: 'Stories',
        imgSrc: 'content_tree_icon.jpg',
        progressCurrent: this.targetLanguage.contentTreeDecksFinishedCount,
        progressTotal: this.targetLanguage.contentTreeDecksCount,
        progressText: 'Story Decks Finished'
      }, {
        background: _constants.Theme.green,
        slug: 'vocab',
        title: 'Vocab',
        description: 'Create your own custom vocab trainer decks and focus on the words you want to learn.',
        webRoute: {
          name: 'vocab.home',
          params: {
            page: 1
          }
        },
        blockAccess: this.userIsLoaded && this.user.freeVocabDecksAvailableCount <= 0,
        mobileRoute: 'Vocab',
        imgSrc: 'vocab_trainer_icon.jpg',
        progressCurrent: this.targetLanguage.vocabTrainerWordsSeenCount,
        progressTotal: this.targetLanguage.vocabTrainerWordsCount,
        progressText: 'Words Seen',
        onClick: function onClick() {
          return _this2.onSetVocabModal('vocab');
        }
      }, {
        blockAccess: this.userIsLoaded && this.user.freeGamesAvailableCount <= 0,
        background: _constants.Theme.purple,
        slug: 'trivia',
        title: 'Trivia',
        description: 'Challenge another student to a fun trivia game while improving your listening comprehension and learning new vocabulary.',
        webRoute: 'trivia.home',
        mobileRoute: 'Trivia',
        imgSrc: 'trivia_icon.jpg',
        progressCurrent: this.targetLanguage.triviaQuestionsAnsweredCount,
        progressTotal: this.targetLanguage.triviaQuestionsAnsweredCount > this.targetLanguage.triviaQuestionsCount ? this.targetLanguage.triviaQuestionsAnsweredCount : this.targetLanguage.triviaQuestionsCount,
        progressText: 'Questions Answered'
      }, {
        blockAccess: this.userIsLoaded && this.user.freeConjugationDecksAvailableCount <= 0,
        background: _constants.Theme.red,
        slug: 'conjugations',
        title: 'Conjugations',
        description: 'Master verb conjugations with our conjugation trainer decks. How many conjugations can you get correct?',
        webRoute: {
          name: 'vocab.home',
          params: {
            page: 1
          }
        },
        mobileRoute: 'Vocab',
        imgSrc: 'conjugation.png',
        progressCurrent: this.targetLanguage.conjugationCardsSeenCount,
        progressTotal: this.targetLanguage.vocabTrainerVerbsCount,
        progressText: 'Conjugation Cards Seen',
        onClick: function onClick() {
          return _this2.onSetVocabModal('conjugation');
        }
      }, {
        blockAccess: this.userIsLoaded && this.user.freeGenderDecksAvailableCount <= 0,
        background: '#6f6f6f',
        slug: 'genders',
        title: 'Genders',
        description: 'Master genders with our fun gender trainer decks. How many genders can you get correct?',
        webRoute: {
          name: 'vocab.home',
          params: {
            page: 1
          }
        },
        mobileRoute: 'Vocab',
        imgSrc: 'der_die_das.png',
        progressCurrent: this.targetLanguage.genderCardsSeenCount,
        progressTotal: this.targetLanguage.vocabTrainerGendersCount,
        progressText: 'Gender Cards Seen',
        onClick: function onClick() {
          return _this2.onSetVocabModal('gender');
        }
      }, {
        blockAccess: this.userIsLoaded && this.user.freePluralDecksAvailableCount <= 0,
        background: _constants.Theme.darkBlue,
        slug: 'plural',
        title: 'Plurals',
        description: 'German plurals have 7 regular and countless irregular forms. How many plurals can you get correct?',
        webRoute: {
          name: 'vocab.home',
          params: {
            page: 1
          }
        },
        mobileRoute: 'Vocab',
        imgSrc: 'plural.png',
        progressCurrent: this.targetLanguage.pluralCardsSeenCount,
        progressTotal: this.targetLanguage.vocabTrainerPluralsCount,
        progressText: 'Plural Cards Seen',
        onClick: function onClick() {
          return _this2.onSetVocabModal('plural');
        }
      }, {
        blockAccess: this.userIsLoaded && this.user.freeNumberDecksAvailableCount <= 0,
        background: _constants.Theme.orange,
        slug: 'number',
        title: 'Numbers',
        description: 'Master numbers with our new number trainer decks. How many numbers can you get correct?',
        webRoute: {
          name: 'vocab.home',
          params: {
            page: 1
          }
        },
        mobileRoute: 'Vocab',
        progressCurrent: this.targetLanguage.numberCardsSeenCount,
        progressTotal: this.targetLanguage.vocabTrainerNumbersCount,
        progressText: 'Number Cards Seen',
        onClick: function onClick() {
          return _this2.onSetVocabModal('number');
        }
      }];
      return contentLinks.filter(function (item) {
        return item.progressTotal > 0;
      }).filter(function (item) {
        return !['plural', 'trivia'].includes(item.slug) || _this2.targetLanguageId === 'DE';
      });
    }
  }, {
    key: "nativeWrapperWidth",
    get: function get() {
      if (this.layout.isNativeTablet && this.layout.viewportWidth > 620) {
        return 600;
      }
      return '100%';
    }
  }, {
    key: "site",
    get: function get() {
      var _this$user2;
      return (_this$user2 = this.user) === null || _this$user2 === void 0 ? void 0 : _this$user2.site;
    }
  }, {
    key: "showPatreonButton",
    get: function get() {
      var _this$site;
      return !this.siteIsDefault && !!((_this$site = this.site) !== null && _this$site !== void 0 && _this$site.patreonClientId);
    }
  }, {
    key: "siteId",
    get: function get() {
      return this.site ? this.site.id : null;
    }
  }, {
    key: "groupId",
    get: function get() {
      var _this$site2;
      return (_this$site2 = this.site) === null || _this$site2 === void 0 ? void 0 : _this$site2.groupId;
    }
  }, {
    key: "siteIsDefault",
    get: function get() {
      if (this.layout.isNative) {
        return true;
      }
      // remove this to see if it helps with instability
      // of seeing seedlang landing page on white label site
      // else if (isPresent(this.site)) {
      //   return this.site.isDefault;
      // }
      return this.siteIsDefaultFromUrl;
    }
  }, {
    key: "siteIsDefaultFromUrl",
    get: function get() {
      var url = window.location.href;
      if (url.match('ngrok')) {
        var _url$match;
        // E.g.: seedlang.ngrok.io, jeremy-seedlang.eu.ngrok.io
        return (_url$match = url.match(/seedlang(\.\w+)?\.ngrok/)) !== null && _url$match !== void 0 ? _url$match : false;
      }
      return !url.match('easy-languages') && !url.match('members.easy');
    }
  }, {
    key: "loadingUser",
    get: function get() {
      return !(0, _utils.isPresent)(this.user.id) && !this.user.signedOut;
    }
  }, {
    key: "userIsSignedIn",
    get: function get() {
      return this.userIsLoaded && (0, _utils.isPresent)(this.user.id);
    }
  }, {
    key: "userIsSignedInAndNotGuest",
    get: function get() {
      return this.userIsLoaded && !this.user.guest;
    }
  }, {
    key: "languageOptions",
    get: function get() {
      var abbreviations = (0, _lodash.keys)(_constants.Languages);
      return abbreviations.map(function (item) {
        return [item, _constants.Languages[item]];
      });
    }
  }, {
    key: "AiLanguageOptions",
    get: function get() {
      var abbreviations = (0, _lodash.keys)(_constants.Languages);
      return abbreviations.map(function (item) {
        return [item, _constants.AiLanguages[item]];
      });
    }
  }, {
    key: "defaultReviewDeckId",
    get: function get() {
      return this.defaultReviewDeckIdForLanguageId(this.targetLanguageId);
    }
  }, {
    key: "defaultReviewDeckIdForLanguageId",
    value: function defaultReviewDeckIdForLanguageId(languageId) {
      var _this$reviewDeckStore;
      var defaultReviewDeck = this.reviewDeckStore.indexData.find(function (item) {
        return item.defaultReviewDeck && item.languageId === languageId;
      });
      if (defaultReviewDeck) {
        return defaultReviewDeck.id;
      }
      return (_this$reviewDeckStore = this.reviewDeckStore.indexData.filter(function (item) {
        return item.languageId === languageId;
      })[0]) === null || _this$reviewDeckStore === void 0 ? void 0 : _this$reviewDeckStore.id;
    }
  }, {
    key: "languageOptionsForFilter",
    get: function get() {
      var abbreviations = (0, _lodash.keys)(_constants.Languages);
      return abbreviations.map(function (item) {
        return {
          id: item,
          name: _constants.Languages[item]
        };
      });
    }
  }, {
    key: "AiLanguageOptionsForFilter",
    get: function get() {
      var abbreviations = (0, _lodash.keys)(_constants.AiLanguages);
      return abbreviations.map(function (item) {
        return {
          id: item,
          name: _constants.AiLanguages[item]
        };
      });
    }
  }, {
    key: "reviewDeckOptions",
    get: function get() {
      var _this3 = this;
      return this.reviewDeckStore.indexData.filter(function (item) {
        return item.languageId === _this3.targetLanguageId && !item.archived;
      }).map(function (item) {
        return [item.id, item.name];
      });
    }
  }, {
    key: "setAuthUserStoreShowData",
    value: function setAuthUserStoreShowData(resp) {
      this.authUserStore.setShowData(resp);
      if (this.SIMULATE_MOBILE_AUTH) {
        if (this.isBrowser) {
          localStorage.setItem('jwtToken', resp['jwtToken']);
        }
      }
    }
  }, {
    key: "createEvent",
    value: function createEvent(eventType, params) {
      if (!this.user.blockUserTracking) {
        this.eventStore.create({
          data: {
            eventType: eventType,
            params: params
          }
        }, _lodash.noop);
      }
    }
  }, {
    key: "targetLanguage",
    get: function get() {
      var _this4 = this;
      if (!this.userIsLoaded) {
        return {};
      }
      var tl = this.user.targetLanguages.find(function (item) {
        return item.languageId === _this4.targetLanguageId;
      });
      return tl || this.user.defaultTargetLanguage;
    }
  }, {
    key: "setJwtToken",
    value: function setJwtToken(jwtToken) {
      this.api.setJwtToken(jwtToken);
    }
  }, {
    key: "userCreatedInLastWeek",
    get: function get() {
      return this.user.createdWithinLastWeek || this.user.admin;
    }
  }, {
    key: "hasTargetLanguage",
    get: function get() {
      return (0, _utils.isPresent)(this.targetLanguage);
    }
  }, {
    key: "setUpdatedDeviceLanguageId",
    value: function setUpdatedDeviceLanguageId(languageId) {
      this.updatedDeviceLanguageId = languageId;
    }
  }, {
    key: "targetLanguageId",
    get: function get() {
      var _this$user3;
      if (this.updatedDeviceLanguageId && this.updatedDeviceLanguageId !== 'all') {
        return this.updatedDeviceLanguageId;
      } else if (this.layout.deviceLanguageId && this.layout.deviceLanguageId !== 'all') {
        return this.layout.deviceLanguageId;
      } else if ((_this$user3 = this.user) !== null && _this$user3 !== void 0 && _this$user3.targetLanguageId) {
        return this.user.targetLanguageId;
      } else if (!this.siteIsDefault && (0, _utils.isPresent)(this.site)) {
        return this.site.languageId;
      }
      return 'DE';
    }
  }, {
    key: "specialCharacterListByLanguage",
    value: function specialCharacterListByLanguage(languageId) {
      var tl = this.user.targetLanguages.find(function (item) {
        return item.languageId === languageId;
      });
      if (tl) {
        return tl.specialCharacterList;
      }
    }
  }, {
    key: "specialCharacterList",
    get: function get() {
      var _this$site3;
      if (this.siteIsDefault) {
        var _this$targetLanguage;
        return ((_this$targetLanguage = this.targetLanguage) === null || _this$targetLanguage === void 0 || (_this$targetLanguage = _this$targetLanguage.language) === null || _this$targetLanguage === void 0 ? void 0 : _this$targetLanguage.specialCharacterList) || {};
      }
      return ((_this$site3 = this.site) === null || _this$site3 === void 0 || (_this$site3 = _this$site3.language) === null || _this$site3 === void 0 ? void 0 : _this$site3.specialCharacterList) || {};
    }
  }, {
    key: "targetLanguageName",
    get: function get() {
      if (this.targetLanguageId) {
        return _constants.Languages[this.targetLanguageId];
      }
    }
  }, {
    key: "loadUser",
    value: function loadUser(callback) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.authUserStore.getShow({}, (0, _lodash.isFunction)(callback) ? callback : null, options);
    }
  }, {
    key: "loadUserPromise",
    value: function loadUserPromise() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.authUserStore.getShowPromise(params);
    }
  }, {
    key: "onMobileTabChange",
    value: function onMobileTabChange() {
      this.mobileTabChangeTimeStamp = +new Date();
    }
  }, {
    key: "wasUiElementSeen",
    value: function wasUiElementSeen(element) {
      if (!this.userIsLoaded) {
        return true;
      }
      return this.user.wasUiElementSeen(element);
    }
  }, {
    key: "designateUiElementAsSeen",
    value: function designateUiElementAsSeen(uiElement) {
      if ((0, _utils.isPresent)(uiElement) && this.user && !this.user.wasUiElementSeen(uiElement)) {
        this.user.designateUiElementAsSeen(uiElement);
        this.authUserStore.update({
          data: {
            ui_elements_seen: this.user.uiElementsSeen
          }
        });
      }
    }
  }, {
    key: "isUnpublishedAccessBlocked",
    get: function get() {
      var _this$site4;
      return !this.siteIsDefault && !((_this$site4 = this.site) !== null && _this$site4 !== void 0 && _this$site4.published) && this.getCookieValue('allowUnpublishedAccess') !== 'yes' && (0, _utils.isBlank)(this.getCookieValue('early-access-token'));
    }
  }, {
    key: "signOut",
    value: function signOut() {
      var _this$user4;
      if (this.isDevelopment && !this.layout.isNative) {
        (0, _utils.deleteAllCookies)(); // useful for signing in as other users
      }
      _tree_ui["default"].clearTrees();
      this.reviewDeckStore.clearIndexData();
      if (this.isUnpublishedAccessBlocked) {
        this.route = 'unpublished';
      } else if (!this.siteIsDefault && (_this$user4 = this.user) !== null && _this$user4 !== void 0 && (_this$user4 = _this$user4.site) !== null && _this$user4 !== void 0 && _this$user4.signedOutHomePageRoute) {
        var _this$user5;
        this.route = (_this$user5 = this.user) === null || _this$user5 === void 0 || (_this$user5 = _this$user5.site) === null || _this$user5 === void 0 ? void 0 : _this$user5.signedOutHomePageRoute;
      }
      this.user.set('signedOut', true);
      this.userTreeNodeStore.clearIndexData();
      this.domainString = this.site.domainString;
      this.authenticateStore.signOut({}, this.siteIsDefault ? this.afterSignOutDefault : this.afterSignOut);
    }
  }, {
    key: "afterSignOutDefault",
    value: function afterSignOutDefault() {
      if (this.isBrowser) {
        if (this.SIMULATE_MOBILE_AUTH) localStorage.removeItem('jwtToken');
      }
      this.loadUser(this.routeStore.routeToNamed('landing'));
    }
  }, {
    key: "afterSignOut",
    value: function afterSignOut() {
      if (this.isBrowser) {
        if (this.SIMULATE_MOBILE_AUTH) localStorage.removeItem('jwtToken');
      }
      this.loadUser(this.routeStore.routeToNamed(this.route || 'whitelabel.home'));
      // if (!this.siteIsDefault) {
      //   this.authenticateStore.signInAsGuest({}, this.loadUser);
      // }
    }
  }, {
    key: "routeToSignedInHome",
    value: function routeToSignedInHome() {
      var _this$user6, _this$user7;
      var route;
      if (this.authenticateStore.redirectRouteNameAfterLogin) {
        route = this.authenticateStore.redirectRouteNameAfterLogin;
        this.authenticateStore.redirectRouteNameAfterLogin = null;
      } else if (!window.location.href.match('ngrok') && !window.location.href.match('easy')) {
        route = 'reviews.home';
      } else if (!this.user.guest && (_this$user6 = this.user) !== null && _this$user6 !== void 0 && (_this$user6 = _this$user6.site) !== null && _this$user6 !== void 0 && _this$user6.signedInHomePageRoute) {
        route = this.user.site.signedInHomePageRoute;
      } else if (this.user.guest && (_this$user7 = this.user) !== null && _this$user7 !== void 0 && (_this$user7 = _this$user7.site) !== null && _this$user7 !== void 0 && _this$user7.signedOutHomePageRoute) {
        route = this.user.site.signedOutHomePageRoute;
      } else {
        route = 'whitelabel.home';
      }
      this.routeStore.routeToNamed(route);
    }
  }, {
    key: "createXpAnimation",
    value: function createXpAnimation(params) {
      if (params.xp > 0 && params.triviaCard) {
        this.soundEffectStore.play('correctChime');
      } else if (params.xp > 0) {
        this.soundEffectStore.play('correct');
      } else {
        this.soundEffectStore.play('failure');
      }
      this.xpState.createXpAnimation(params);
    }
  }, {
    key: "onNewRoute",
    value: function onNewRoute() {
      this.pageExpanded = false;
      this.pageHasScrolled = false;
      this.notificationsOpened = false;
      this.streakPopupOpened = false;
    }
  }, {
    key: "onSetVocabModal",
    value: function onSetVocabModal(trainer) {
      this.showVocabModal = trainer;
    }
  }, {
    key: "toggleNotificationsOpened",
    value: function toggleNotificationsOpened() {
      this.streakPopupOpened = false;
      this.notificationsOpened = !this.notificationsOpened;
      if (this.notificationsOpened) {
        this.notificationStore.getIndex({
          limit: 10
        }, this.afterGetNotificationsIndex);
      }
    }
  }, {
    key: "setNativeAudioPlayer",
    value: function setNativeAudioPlayer(nativeSoundEffectPlayer) {
      this.soundEffectStore.setNativeAudioPlayer(nativeSoundEffectPlayer);
    }
  }, {
    key: "getCookieValue",
    value: function getCookieValue(name) {
      return this.cookieStore.getCookieValue(name, this.user);
    }
  }, {
    key: "setCookieValue",
    value: function setCookieValue(name, value) {
      this.cookieStore.setCookieValue(name, value, this.user);
    }
  }, {
    key: "getErrorMessage",
    value: function getErrorMessage() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'general';
      // video, sentence
      return _constants.Constants.ERROR_MESSAGES[this.targetLanguageId] ? _constants.Constants.ERROR_MESSAGES[this.targetLanguageId][type] : _constants.Constants.ERROR_MESSAGES['EN'][type];
    }
  }, {
    key: "routeToHome",
    value: function routeToHome() {
      if (this.blockRouteToHome) {
        return;
      }
      if (this.user.signedOut && this.siteIsDefault) {
        this.routeStore.routeToNamed('landing');
      } else if (this.siteIsDefault) {
        this.routeStore.routeToNamed('reviews.home');
      } else if (this.user) {
        this.routeToSignedInHome();
      } else {
        this.routeStore.routeToNamed('whitelabel.home');
      }
    }
  }, {
    key: "toggleStreakPopupOpened",
    value: function toggleStreakPopupOpened() {
      this.notificationsOpened = false;
      this.streakPopupOpened = !this.streakPopupOpened;
    }
  }, {
    key: "afterGetNotificationsIndex",
    value: function afterGetNotificationsIndex(resp) {
      this.notificationStore.setIndexData(resp);
      this.notificationStore.clear();
      this.user.resetUnseenNotifications();
    }
  }, {
    key: "env",
    get: function get() {
      return !this.layout.isNative && (window.location.href.match('localhost') || window.location.href.match('ngrok')) ? 'development' : 'production';
    }
  }, {
    key: "isDevelopment",
    get: function get() {
      return this.env === 'development';
    }
  }, {
    key: "loadReviews",
    value: function loadReviews(cardId) {
      this.loadingReviews = true;
      this.reviewStore.getIndex({
        ids: {
          cardId: cardId
        },
        limit: 10,
        sort: '-created_at'
      }, this.afterGetReviews.bind(this));
    }
  }, {
    key: "updateContractedModulesAry",
    value: function updateContractedModulesAry(contractedModulesAry) {
      this.contractedModulesAry = contractedModulesAry;
    }
  }, {
    key: "afterGetReviews",
    value: function afterGetReviews(resp) {
      this.reviewStore.setIndexData(resp);
      this.loadingReviews = false;
    }
  }, {
    key: "detectDataSaver",
    value: function detectDataSaver() {
      if ('connection' in navigator) {
        if (navigator.connection.saveData === true) {
          this.usingDataSaverHeader = true;
        }
      }
    }
  }, {
    key: "closeDeck",
    value: function closeDeck() {
      this.loadUser();
      this.userTreeNodeStore.getIndex();
      _exercise_ui["default"].set('assignedExercise', null);
      if (_deck_ui["default"].deck.deckType === 'review') {
        // need to update deck counts after finishing review deck
        this.reloadReviewDecks = true;
      }
      _deck_ui["default"].onCloseDeck();
      this.xpState.clearAllAnimations();
    }
  }, {
    key: "loadReviewDecks",
    value: function loadReviewDecks(callback) {
      this.reloadReviewDecks = false;
      this.reviewDeckStore.setLimit(200);
      this.reviewDeckStore.getIndex({}, callback);
    }
  }, {
    key: "reloadFeed",
    value: function reloadFeed() {
      this.feedEntryStore.getIndex();
    }
  }, {
    key: "createOrUpdateUserTranslation",
    value: function createOrUpdateUserTranslation(word, data, callback) {
      if (word.userTranslationId) {
        this.userTranslationStore.update({
          data: data,
          ids: {
            userTranslationId: word.userTranslationId
          }
        });
      } else {
        data.translationId = word.id;
        this.userTranslationStore.create({
          data: data
        }, callback);
      }
    }
  }, {
    key: "gotoPrivacy",
    value: function gotoPrivacy() {
      _overlay_ui["default"].addOverlay('privacy', {
        overlayTitle: 'Privacy'
      });
    }
  }, {
    key: "gotoPartners",
    value: function gotoPartners() {
      _overlay_ui["default"].addOverlay('partners', {
        overlayTitle: 'Partners'
      });
    }
  }, {
    key: "gotoSettings",
    value: function gotoSettings() {
      _overlay_ui["default"].addOverlay('settings', {
        overlayTitle: 'Settings'
      });
    }
  }, {
    key: "gotoFaq",
    value: function gotoFaq() {
      _overlay_ui["default"].addOverlay('faq', {
        overlayTitle: 'FAQ'
      });
    }
  }, {
    key: "gotoContact",
    value: function gotoContact() {
      _overlay_ui["default"].addOverlay('contact', {
        overlayTitle: 'Contact'
      });
    }
  }, {
    key: "gotoProfile",
    value: function gotoProfile(user) {
      if (this.layout.isMobile) {
        _overlay_ui["default"].addOverlay('profile', {
          overlayTitle: 'Profile',
          params: {
            userId: user.id
          }
        });
      } else {
        this.routeStore.routeToNamed('profiles.show', {
          userId: user.id
        });
      }
    }
  }, {
    key: "scrollToPageTop",
    value: function scrollToPageTop() {
      var behavior = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'smooth';
      var pageTopId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'page-top';
      var top = 0;
      var pageTop = document.getElementById(pageTopId);
      if ((0, _utils.isPresent)(pageTop) && !this.topIsInView(pageTop)) {
        if ((0, _utils.isPresent)(pageTop) && pageTop.getBoundingClientRect()) {
          top += pageTop.getBoundingClientRect().top;
        }
      }
      if (this.layout.isMobile) {
        setTimeout(function () {
          window.scroll({
            top: top,
            left: 0,
            behavior: behavior
          });
        }, 10);
      } else {
        var _document$getElements;
        (_document$getElements = document.getElementsByClassName('app')[0]) === null || _document$getElements === void 0 || _document$getElements.scrollTo({
          top: top - 80,
          behavior: behavior
        });
      }
    }
  }, {
    key: "topIsInView",
    value: function topIsInView(el) {
      var rect = el.getBoundingClientRect();
      return rect.top >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight);
    }
  }, {
    key: "paymentMigrationEnabled",
    get: function get() {
      if (this.siteIsDefault || !this.site.patreonClientId) return false;
      return !!this.site.patreonClientId || this.env === 'development' || this.user.admin || window.location.search === '?test';
    }
  }, {
    key: "isPaymentMigrationInProgress",
    get: function get() {
      var _this$user$paymentMig;
      return ((_this$user$paymentMig = this.user.paymentMigration) === null || _this$user$paymentMig === void 0 ? void 0 : _this$user$paymentMig.status) && this.user.paymentMigration.isInProgress;
    }
  }, {
    key: "isPaymentMigrationStartable",
    get: function get() {
      var _this$user$paymentMig2, _this$user$patreonUse;
      return !!this.site.patreonClientId && this.paymentMigrationEnabled && ((_this$user$paymentMig2 = this.user.paymentMigration) === null || _this$user$paymentMig2 === void 0 ? void 0 : _this$user$paymentMig2.isUnstarted) && this.user.isMember && ((_this$user$patreonUse = this.user.patreonUser) === null || _this$user$patreonUse === void 0 ? void 0 : _this$user$patreonUse.isPatreonActive) && (!this.user.admin || this.env === 'development');
    }
  }, {
    key: "shouldBlockPerksForMigration",
    get: function get() {
      var _this$user$patreonUse2, _this$user$paymentMig3;
      if (!!this.site.patreonClientId || !this.paymentMigrationEnabled || !this.user.isMember || !((_this$user$patreonUse2 = this.user.patreonUser) !== null && _this$user$patreonUse2 !== void 0 && _this$user$patreonUse2.isPatreonActive)) {
        return false;
      }
      // Block users who haven't completed migration (haven't reached waiting_for_patreon_expiry)
      var blockingStatuses = ['setting_up', 'stripe_payment_setup_started', 'waiting_for_patreon_cancellation'];
      return ((_this$user$paymentMig3 = this.user.paymentMigration) === null || _this$user$paymentMig3 === void 0 ? void 0 : _this$user$paymentMig3.status) && blockingStatuses.includes(this.user.paymentMigration.status);
    }
  }, {
    key: "vocabBlockedUntilMigrated",
    get: function get() {
      return this.shouldBlockPerksForMigration && this.site.blockVocabIfNotMigrated;
    }
  }, {
    key: "exercisesBlockedUntilMigrated",
    get: function get() {
      return this.shouldBlockPerksForMigration && this.site.blockExercisesIfNotMigrated;
    }
  }, {
    key: "userIsGroupAdmin",
    get: function get() {
      return this.user.isAdminForSite(this.site.id);
    }
  }]);
}(_root_state["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "allowPageScroll", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "notificationsOpened", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "streakPopupOpened", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "submittingPayment", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "usingDataSaverHeader", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "registrationSubmitted", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "hideOnboarding", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "expandedEmailRegistrationFields", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "loadingReviews", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "blockRouteToHome", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "reloadReviewDecks", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "currentlyViewedMembership", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "routeToMobile", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "vocabWordTypeId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "nativeDevice", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "mobileTabChangeTimeStamp", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "showUpdateAppModal", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "showUpdateLangModal", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "showImagePickerModal", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "showVocabModal", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "clickedLinkId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "updatedDeviceLanguageId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "showFirstDeckCompletionModal", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "onboardingDeckType", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "onboardingDeckId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "onboardingTreeNodeId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "pageHasScrolled", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "pageExpanded", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "contentTreeScrollPosition", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "worksheetGridScrollPosition", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "contractedModulesAry", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "onboardingLevelId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "onboardingLanguageId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "isBrowser", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
  }
}), _applyDecoratedDescriptor(_class.prototype, "user", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "user"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userIsLoaded", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userIsLoaded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "permissions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "permissions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "contentLinks", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "contentLinks"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nativeWrapperWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "nativeWrapperWidth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "site", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "site"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showPatreonButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showPatreonButton"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "siteId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "siteId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "groupId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "groupId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "siteIsDefault", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "siteIsDefault"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "siteIsDefaultFromUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "siteIsDefaultFromUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadingUser", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "loadingUser"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userIsSignedIn", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userIsSignedIn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userIsSignedInAndNotGuest", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userIsSignedInAndNotGuest"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "languageOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "languageOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "AiLanguageOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "AiLanguageOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "defaultReviewDeckId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultReviewDeckId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "defaultReviewDeckIdForLanguageId", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "defaultReviewDeckIdForLanguageId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "languageOptionsForFilter", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "languageOptionsForFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "AiLanguageOptionsForFilter", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "AiLanguageOptionsForFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reviewDeckOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "reviewDeckOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setAuthUserStoreShowData", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setAuthUserStoreShowData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createEvent", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "createEvent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "targetLanguage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "targetLanguage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setJwtToken", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setJwtToken"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userCreatedInLastWeek", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userCreatedInLastWeek"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasTargetLanguage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasTargetLanguage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setUpdatedDeviceLanguageId", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setUpdatedDeviceLanguageId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "targetLanguageId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "targetLanguageId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "specialCharacterListByLanguage", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "specialCharacterListByLanguage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "specialCharacterList", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "specialCharacterList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "targetLanguageName", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "targetLanguageName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadUser", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "loadUser"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadUserPromise", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "loadUserPromise"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onMobileTabChange", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onMobileTabChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wasUiElementSeen", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "wasUiElementSeen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "designateUiElementAsSeen", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "designateUiElementAsSeen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isUnpublishedAccessBlocked", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isUnpublishedAccessBlocked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "signOut", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "signOut"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterSignOutDefault", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "afterSignOutDefault"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterSignOut", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "afterSignOut"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "routeToSignedInHome", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "routeToSignedInHome"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createXpAnimation", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "createXpAnimation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onNewRoute", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onNewRoute"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSetVocabModal", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onSetVocabModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleNotificationsOpened", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleNotificationsOpened"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setNativeAudioPlayer", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setNativeAudioPlayer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getCookieValue", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "getCookieValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCookieValue", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setCookieValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getErrorMessage", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "getErrorMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "routeToHome", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "routeToHome"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleStreakPopupOpened", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleStreakPopupOpened"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterGetNotificationsIndex", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "afterGetNotificationsIndex"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "env", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "env"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDevelopment", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDevelopment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateContractedModulesAry", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "updateContractedModulesAry"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterGetReviews", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "afterGetReviews"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "detectDataSaver", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "detectDataSaver"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeDeck", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadReviewDecks", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "loadReviewDecks"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reloadFeed", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "reloadFeed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createOrUpdateUserTranslation", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "createOrUpdateUserTranslation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoPrivacy", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoPrivacy"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoPartners", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoPartners"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoSettings", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoSettings"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoFaq", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoFaq"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoContact", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoContact"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoProfile", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "scrollToPageTop", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "scrollToPageTop"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "topIsInView", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "topIsInView"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "paymentMigrationEnabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "paymentMigrationEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPaymentMigrationInProgress", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPaymentMigrationInProgress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPaymentMigrationStartable", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPaymentMigrationStartable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shouldBlockPerksForMigration", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "shouldBlockPerksForMigration"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabBlockedUntilMigrated", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabBlockedUntilMigrated"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "exercisesBlockedUntilMigrated", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "exercisesBlockedUntilMigrated"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userIsGroupAdmin", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userIsGroupAdmin"), _class.prototype), _class);
var _default = exports["default"] = new AppUI();